/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface TestEnqueteHistoryListPayload {
    careerId: string;
    classId: string;
}

export interface HistoryListItem {
    disableFlg: string;
    endDate: string;
    enqueteUpdDate: string;
    startDate: string;
    thistoryId: string;
    tokuten: string;
}

export interface TestEnqueteListItem {
    displayStyle: number;
    historyCount: number;
    id: string;
    kind: string;
    title: string;
    paperType: string;
    historyList: HistoryListItem[];
}

export interface TestEnqueteHistoryListResponse {
    testEnqueteList: TestEnqueteListItem[];
}

class TestEnqueteHistoryListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "testEnqueteHistoryList");
    }

    // テストアンケート履歴一覧取得
    public async testEnqueteHistoryList(
        payload: TestEnqueteHistoryListPayload,
        resolved: (json: TestEnqueteHistoryListResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as TestEnqueteHistoryListResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default TestEnqueteHistoryListService;
